import type { ComponentType } from 'react';

import { Node_Type } from './../../../../../ricos-schema/legacy/wix/rich_content/v1';
import type { NodeViewRenderers, PluginMapping, ViewerContextualData } from './../../../../../ricos-types';

import type { PluginComponent } from '../../../types';
import { fromExternalNode } from './fromExternalNode';

type GetPluginRenderers = (
  context: ViewerContextualData,
  typeMappers: PluginMapping,
  nodeViewRenderers: NodeViewRenderers,
  SpoilerViewerWrapper?: ComponentType<{ className: unknown; width?: number }>
) => NodeViewRenderers;

export const getPluginRenderers: GetPluginRenderers = (
  context,
  typeMappers,
  nodeViewRenderers,
  SpoilerViewerWrapper
) => {
  const convertedTypeMappers = Object.entries(typeMappers).reduce(
    (renderers, [type, pluginComponent]: [string, PluginComponent]) => {
      if (type === Node_Type.EXTERNAL) {
        return {
          ...renderers,
          ...fromExternalNode({ pluginComponent, type, context, SpoilerViewerWrapper }),
        };
      }

      return { ...renderers };
    },
    {}
  );
  return { ...convertedTypeMappers, ...nodeViewRenderers };
};
